/**
 * Service principal returned by Bearer/M2M auth.
 * Not CASL-evaluated — leave unannotated (auth-surfaces).
 *
 * Scopes come from the M2M JWT `scope` claim (space-delimited permission
 * slugs assigned to the application). Authz is claim-based — there is no
 * client-id→scopes map in code.
 */
export class ServiceUserRecordDto {
  authProviderName!: string;

  /**
   * System user id (`API_AUTHN_SYSTEM_USER_ID`).
   * Used when the authenticated entity has no human user record.
   */
  id!: number;

  /**
   * Numeric `tenants.id` PK from request context (`getTenantId()`).
   * Not an `org_…` string — that lives on `UserRecordDto.tenantOrgId`.
   */
  tenantId!: number;

  /**
   * Tenant name for the active request context (not stored).
   */
  tenantName!: string;

  /**
   * M2M application client id (`sub` / `client_id` claim).
   */
  clientId!: string;

  /**
   * Permission slugs from the JWT `scope` claim (e.g. `billing:apply`).
   */
  scopes!: string[];
}
